import React, { CSSProperties, FC, ReactNode } from 'react';
import classes from './styles/index.module.scss';
import { PaddingBoxPosition, PaddingBoxSize } from "./const";
import classNames from "classnames";

type PaddingBoxRenderType = {
    [key in `${PaddingBoxSize}${PaddingBoxPosition}`]?: boolean;
} & {
    [key in `${PaddingBoxSize}`]?: boolean;
} & {
    className?: string;
    style?: CSSProperties;
    children?: ReactNode;
}

type PaddingBoxType = PaddingBoxRenderType & {
    render?: FC<PaddingBoxRenderType>;
}

export const PaddingBox: FC<PaddingBoxType> = (
    { children, render, className, style, ...props }
) => {
    // @ts-ignore
    const paddingBoxClassNames = classNames(Object.keys(props).filter((item) => props[item]).map(item => classes[item]), className);

    if(render) {
        return render({className: paddingBoxClassNames, style, children});
    }

    return (
        <div style={style} className={paddingBoxClassNames}>
            {children}
        </div>
    );
}